function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    focusable: "false",
    "aria-hidden": "true",
    stroke: "#4b5661",
    fill: "none",
    style: {
      display: "block",
      maxWidth: "100%",
      maxInlineSize: "100%",
      maxHeight: "100%",
      maxBlockSize: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 10.5h-.9a.7.7 0 0 1-.7-.7V3.5a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v7H5.4m-2.4 0a1.2 1.2 0 0 0 2.4 0m3.2 0a1.2 1.2 0 0 0 2.4 0",
    style: {
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.4 10.5a1.2 1.2 0 0 0-2.4 0m8 0a1.2 1.2 0 0 0-2.4 0m-1.6 0h1.6",
    style: {
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 10.5h.9a.7.7 0 0 0 .7-.7V7H7m0-2.8h2.51a.7.7 0 0 1 .495.205L12.6 7",
    style: {
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.4px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanIcon);
export default __webpack_public_path__ + "static/media/vanIcon.af14871fb4fa535fb76db264454777e4.svg";
export { ForwardRef as ReactComponent };